import Smartphones from './Smartphones'
import Tablets from './Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const Integration = getCurrentDeviceView(Smartphones, Tablets)

export default Integration
